import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AlertNotificationService } from '../../../services/alert-notification.service';
import { SelectFieldComponent } from '../../form/select-field/select-field.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-select-base-options-field',
  imports: [SelectFieldComponent],
  templateUrl: './select-base-options-field.component.html',
  styleUrl: './select-base-options-field.component.scss'
})
export class SelectBaseOptionsFieldComponent implements OnInit, OnDestroy {
  @Input() label?: string;
  @Input() selectFormControl!: FormControl;
  @Input() readonly!:boolean
  options: { key: string, value: string }[] = []
  private pendingValue: any = null;
  private formControlSubscription?: Subscription;

  ngOnInit(): void {
    if (this.selectFormControl) {
      this.formControlSubscription = this.selectFormControl.valueChanges.subscribe(value => {
        if (value && this.options.length === 0) {
          this.pendingValue = value;
        }
      });

      const initialValue = this.selectFormControl.value;
      if (initialValue && this.options.length === 0) {
        this.pendingValue = initialValue;
      }
    }
  }

  ngOnDestroy(): void {
    if (this.formControlSubscription) {
      this.formControlSubscription.unsubscribe();
    }
  }

  public getOptions(service: any, alertNotificationService: AlertNotificationService): void {
    service?.subscribe({
      next: (response: any) => {
        if (response && response.data && response.data.options) {
          this.setOptionsFromArray(response.data.options);
        }
      },
      error: (error: any) => {
        console.error('Errore durante il caricamento dello status:', error);
        alertNotificationService.error('Errore durante il caricamento');
      }
    });
  }

  protected setOptionsFromArray(rawOptions: { key: string, value: string }[]): void {
    this.options = [
      {
        key: '',
        value: '-- select'
      },
      ...rawOptions
    ]

    if (this.pendingValue !== null && this.selectFormControl) {
      this.selectFormControl.setValue(this.pendingValue);
      this.pendingValue = null;
    }
  }

  public setValue(value: any): void {
    if (this.options.length > 0) {
      this.selectFormControl.setValue(value);
    } else {
      this.pendingValue = value;
    }
  }
}
